// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Actor, createActor, StateMachine, type AnyActorLogic, type AnyActorRef, type AnyEventObject, type EventObject, type MachineContext, type MetaObject, type NonReducibleUnknown, type ParameterizedObject, type ProvidedActor, type StateValue } from 'xstate';

import type { EditorView } from '@atlaskit/editor-prosemirror/view';

import { editorPluginAIMachine } from './editor-plugin-ai-machine';

/**
 * Weakmap cache for caching an [actor](https://xstate.js.org/docs/guides/actors.html#actor-api)
 * per EditorView.
 *
 * It contains a convenience function for returning an actor if it exists in the cache (`getActor`)
 */
class AIActorCache extends WeakMap<EditorView, ReturnType<typeof createActor>> {
	/**
	 * Returns an actor if it exists in the cache or creates and starts a new one.
	 *
	 * @param editorView
	 * @returns [actor](https://xstate.js.org/docs/guides/actors.html#actor-api)
	 */
 // eslint-disable-next-line @typescript-eslint/no-explicit-any
	getActor(editorView: EditorView): Actor<AnyActorLogic> | Actor<StateMachine<MachineContext, AnyEventObject, Record<string, AnyActorRef>, ProvidedActor, ParameterizedObject, ParameterizedObject, string, StateValue, string, unknown, NonReducibleUnknown, EventObject, MetaObject, any>> | undefined {
		if (this.has(editorView)) {
			return this.get(editorView);
		}
		const editorPluginAIActor = createActor(editorPluginAIMachine);
		editorPluginAIActor.start();
		aiActorCache.set(editorView, editorPluginAIActor);
		return editorPluginAIActor;
	}
}

/**
 * Global cache used to manage an an [actor](https://xstate.js.org/docs/guides/actors.html#actor-api) per
 * EditorView for the AI Editor Plugin.
 */
export const aiActorCache: AIActorCache = new AIActorCache();
